import {Block, Property, Action, Util} from "./index";
import {STATE, GRAMMAR} from "../Type";
import Line from "../Line";

export class Variable extends Block {
  get type() {
    return "Variable";
  }

  get category() {
    return "Variable";
  }

  getGrammarFor(parent) {
    if (parent instanceof Line) {
      return GRAMMAR.SUBJECT;
    } else {
      return GRAMMAR.OBJECTIVE;
    }
  }
  getDefaultChildren() {
    if (this.grammar === GRAMMAR.SUBJECT) {
      return [new Block({state: STATE.INSTANCE, parent: this})];
    } else {
      return [];
    }
  }

  static getPrototypeBlocks(variables) {
    const prototypeBlocks = [];
    for (let i in variables) {
      const variable = variables[i];
      prototypeBlocks.push(new Variable({data: variable, state: STATE.PROTOTYPE}));
    }
    return prototypeBlocks;
  }
  getAvailableChildTypesAt(index) {
    if (this.grammar === GRAMMAR.SUBJECT) {
      return [Property, Action, Util];
    } else if (this.grammar === GRAMMAR.OBJECTIVE) {
      return [Property];
    } else {
      return [];
    }
  }

  getPropertyType() {
    return [Block];
  }

  toJavascript() {
    const variableId = this.data;
    const child = this.children && this.children[0];
    if (child) {
      const childCode = child.toJavascript();
      return `global.${variableId}${childCode}`;
    } else {
      return `global.${variableId}`;
    }
  }
}
